import { log } from '../../services/utils';

import { controller } from '../../contexts/ProgramsContext';

import { noraApiRequest } from './';

export const getProgramList = async () => {
	log( '* get program list' );
	const { data } = await noraApiRequest( {
		url: '/programs',
		signal: controller.signal
	} );

	return data;
};

export const getProgram = async id => {
	log( '* get program' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createProgram = async data => {
	log( '* create program' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: '/programs',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateProgram = async data => {
	log( '* update program' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: '/programs',
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteProgram = async id => {
	log( '* delete program' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/programs/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const updateProgramPhoto = async ( id, photoId ) => {
	log( '* update program photo' );
	const response = await noraApiRequest( {
		method: 'PATCH',
		url: `/programs/${ id }/photo/${ photoId }`,
		signal: controller.signal
	} );

	return response.data;
};

export const getProgramSubmissionTemplatesByType = async ( id, docTypeId ) => {
	log( '* get program submission templates by type' );
	const response = await noraApiRequest( {
		method: 'GET',
		url: `/programs/${ id }/documents/type/${ docTypeId }`,
		signal: controller.signal
	} );

	return response.data;
};

/* submissions */

export const getProgramSubmissions = async programId => {
	log( '* get program submission list' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ programId }/submissions`,
		signal: controller.signal
	} );

	return data;
};

export const exportProgramSubmissions = async ids => {
	log( '* export program submissions' );

	const response = await noraApiRequest( {
		method: 'POST',
		url: '/programs/submissions/export',
		data: { ids },
		signal: controller.signal
	} );

	return response.data;
};

/* coordination */

export const getCoordinationList = async programId => {
	log( '* get program coordination list' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ programId }/coordination`,
		signal: controller.signal
	} );

	return data;
};

export const assignCoordination = async ( programId, data ) => {
	log( '* assign program coordination' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/coordination/assign`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const unassignCoordination = async ( programId, id ) => {
	log( '* unassign program coordination' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/coordination/unassign/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

/* documents */

export const getTemplateList = async programId => {
	log( '* get program submission template list' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ programId }/documents`,
		signal: controller.signal
	} );

	return data;
};

export const getTemplate = async ( programId, id ) => {
	log( '* get submission template' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ programId }/documents/${ id }`,
		signal: controller.signal
	} );

	return data;
};

export const createTemplate = async ( programId, data ) => {
	log( '* create submission template' );
	const response = await noraApiRequest( {
		method: 'POST',
		url: `/programs/${ programId }/documents`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const updateTemplate = async ( programId, data ) => {
	log( '* update submission Template' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/documents`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const deleteTemplate = async ( programId, id ) => {
	log( '* delete submission template' );
	const response = await noraApiRequest( {
		method: 'DELETE',
		url: `/programs/${ programId }/documents/${ id }`,
		signal: controller.signal
	} );

	return response.data;
};

export const pauseTemplate = async ( programId, id ) => {
	log( '* pause submission template' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/documents/${ id }/pause`,
		signal: controller.signal
	} );

	return response.data;
};

export const unpauseTemplate = async ( programId, id ) => {
	log( '* unpause submission template' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/documents/${ id }/unpause`,
		signal: controller.signal
	} );

	return response.data;
};

export const getTemplateModuleTags = async () => {
	log( '* lookup submission template module tags' );
	const { data } = await noraApiRequest( {
		url: '/programs/documents/modules/lookups/labels',
		signal: controller.signal
	} );

	return data;
};

/* participants */

export const getParticipantsList = async programId => {
	log( '* get program participants list' );
	const { data } = await noraApiRequest( {
		url: `/programs/${ programId }/participants`,
		signal: controller.signal
	} );

	return data;
};

export const enrollParticipant = async ( programId, data ) => {
	log( '* add program participant' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/participants/enroll`,
		data,
		signal: controller.signal
	} );

	return response.data;
};

export const unenrollParticipant = async ( programId, agencyId ) => {
	log( '* delete program participant' );
	const response = await noraApiRequest( {
		method: 'PUT',
		url: `/programs/${ programId }/participants/unenroll/${ agencyId }`,
		signal: controller.signal
	} );

	return response.data;
};

export const exportProgramList = async ids => {
	log( '* export program list' );

	const response = await noraApiRequest( {
		method: 'POST',
		url: '/programs/export',
		data: { ids },
		signal: controller.signal
	} );

	return response.data;
};

// overview
export const overviewSearchBySubmission = async ( programId, instanceId ) => {
	log( '* overview search by submission' );

	const response = await noraApiRequest( {
		method: 'GET',
		url: `/programs/${ programId }/overview/template/0/instance/${ instanceId }`,
		signal: controller.signal
	} );

	return response.data;
};

export const overviewSearchByAgency = async ( programId, agencyId ) => {
	log( '* overview search by agency' );

	const response = await noraApiRequest( {
		method: 'GET',
		url: `/programs/${ programId }/overview/template/0/instance/0/agency/${ agencyId }`,
		signal: controller.signal
	} );

	return response.data;
};
